import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export const Panel = ({ title, sub, children, testid, right }) => (
  <section className="bg-white border border-slate-200 rounded-xl p-4 space-y-3" data-testid={testid}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div><h3 className="text-sm font-semibold text-slate-900">{title}</h3>{sub && <p className="text-xs text-slate-500 max-w-3xl">{sub}</p>}</div>{right}
    </div>
    {children}
  </section>
);

export const Ok = ({ ok, children, testid }) => (
  <div className="flex items-start gap-2 text-xs" data-testid={testid}>
    {ok ? <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" /> : <XCircle className="w-4 h-4 text-red-500 shrink-0" />}<span className="text-slate-700">{children}</span>
  </div>
);

const TONES = { slate: "bg-slate-50 border-slate-200", emerald: "bg-emerald-50 border-emerald-200", amber: "bg-amber-50 border-amber-200", red: "bg-red-50 border-red-200" };

export const Stat = ({ label, value, tone = "slate", testid }) => (
  <div className={`rounded-lg border px-3 py-2 ${TONES[tone]}`} data-testid={testid}>
    <p className="text-[11px] text-slate-500">{label}</p><p className="text-lg font-bold text-slate-900">{Number(value || 0).toLocaleString()}</p>
  </div>
);

export const When = ({ at }) => (at ? <span className="text-[11px] text-slate-400">Last run {new Date(at).toLocaleString()}</span> : null);
